module.exports = __webpack_public_path__ + "img/sinBarreras.7a27a3e2.jpg";